/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Browser Warning Modal Component
 *
 * @author Aleksandr Perkhunov
 * @version 1.4.1
 * @since 1.4.1
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { icons } from '../../../../assets';
import { makeSelectTranslationCommon } from '../../../../modules/internationalization/intSelectors';
import { ICommonTranslation } from '../../../../modules/internationalization/types';
import { IRootReducer } from '../../../../reducers/rootReducer';
import { ImgStyled } from '../../../common/Block/Img';
import {
    FooterModalImageStyled,
    FooterModalStyled,
    FooterModalTextStyled,
    FooterModalTitleStyled,
} from './styled/footerModalStyled';

const BrowserWarningModal = (props: IConnectedProps) => {
    return (
        <FooterModalStyled style={{ textAlign: 'center' }}>
            <FooterModalImageStyled>
                <ImgStyled height="137px" src={icons.browserWarning} width="108px"/>
            </FooterModalImageStyled>
            <FooterModalTitleStyled className="mb-3">
                {props.translation.browserWarning.title}
            </FooterModalTitleStyled>
            <FooterModalTextStyled>
                <div dangerouslySetInnerHTML={{
                    __html: props.translation.browserWarning.html,
                }}/>
            </FooterModalTextStyled>
        </FooterModalStyled>
    );
};

interface IConnectedProps {
    translation: ICommonTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    translation: makeSelectTranslationCommon(),
});

export default connect(mapStateToProps)(BrowserWarningModal);
